/* Retirar Carousel */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { View, Image, Text, TouchableOpacity } from 'react-native';
import { LinearGradient } from "expo-linear-gradient";
import AsyncStorage from '@react-native-async-storage/async-storage';
// import Carousel, { Pagination } from 'react-native-snap-carousel';
import { useIsFocused } from '@react-navigation/native';
import api from '../../services/api';
import ScreenLoader from '../../components/ScreenLoader'
import HeaderTabs from '../../components/HeaderTabs';

import styles from "./styles";

const MarketplaceCategories = ({ navigation }) => {
    const ref = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [categories, setCategories] = useState([]);
    const isFocused = useIsFocused();
    const [loading1, setLoading1] = useState(false);


    useEffect(() => {
        getCategories();
    }, [isFocused]);

    async function getCategories() {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        setLoading1(true)
        api.get('/categories', { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                var arrCategories = [];

                res.data.map(item => {
                    arrCategories.push(item);
                });
                setCategories(arrCategories[0]);
                setLoading1(false)
            })
            .catch((error) => {
                setLoading1(false)
                console.log(error);
            });
    }

    async function selectedCategory(id) {
        await AsyncStorage.setItem("id_category", id.toString());
        navigation.navigate('Marketplace');
    }

    const renderItem = useCallback((item) => {
        return (
            <View style={styles.card} key={item.id}>
                <View>
                    <Image
                        style={styles.frontCover}
                        source={{ uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}` }}
                    />
                    <Text style={styles.nameCategory}>{item.name}</Text>
                </View>
                <View style={styles.contentDescription}>
                    <Text style={styles.description}>{item.description}</Text>
                </View>
                <View style={styles.contentBtn}>
                    <TouchableOpacity style={styles.button} onPress={() => selectedCategory(item.id)}>
                        <LinearGradient
                            start={{ x: -1, y: 0 }}
                            end={{ x: 1, y: 0 }}
                            colors={["#16195B", "#1FBFB5"]}
                            style={styles.btn}
                        >
                            <Text style={styles.textBtn}>QUERO INVESTIR</Text>
                        </LinearGradient>
                    </TouchableOpacity>
                </View>
            </View>
        );
    }, []);

    return (
        <>
            <ScreenLoader loading={loading1} />

            <HeaderTabs
                title={"MARKETPLACE"}
                iconLeft={"settings"}
                routeLeft={"MyAccount"}
                subtitle={"Escolha e compre seus tokens aqui"}
            />

            <View style={styles.container}>
                {categories.map(((item) => renderItem(item)))}
            </View>
        </>
    );
}

export default MarketplaceCategories;